'use client'
import { useAgentAuthDetails } from '@repo/services'
import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Link } from '@repo/shared/i18n/navigation'
import { globalConfig } from '@repo/shared/utils'
import { Cookie } from '@repo/tools'
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Card,
  Col,
  Icon,
  Row,
  Typography,
} from '@repo/ui/components'
import { useIsDesktop } from '@repo/ui/hooks'
import { cn } from '@repo/ui/lib'
import { useEffect } from 'react'
import { AuthHeaderLayout } from '@repo/auth/containers'
import { DashboardAgentsHeaderSkeleton } from './dashboard-agents.header.skeleton'

export const DashboardAgentsHeader = ({
  showUserProfile,
}: {
  showUserProfile: boolean
}) => {
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()

  const { data: { data: authDetails } = {}, isLoading } = useAgentAuthDetails()

  useEffect(() => {
    if (authDetails?.details?.kyc?.status) {
      Cookie.set(
        'kyc_status',
        authDetails?.details?.kyc?.status || 'undefined',
        {
          path: '/',
        },
      )
      Cookie.set(
        'kyc_reason',
        authDetails?.details?.kyc?.comment || 'undefined',
        {
          path: '/',
        },
      )
    }
  }, [authDetails?.details?.kyc?.status])

  if (isLoading) {
    return <DashboardAgentsHeaderSkeleton />
  }

  return (
    <Card
      className={cn(
        'p-md md:p-lg rounded-none md:rounded-md  flex flex-col md:flex-row items-start md:items-center justify-between w-full gap-md md:gap-0',
        !isDesktop && 'dark bg-neutral-surface-dark',
      )}
    >
      {!isDesktop && (
        <Col className='items-center  justify-between gap-md'>
          <AuthHeaderLayout isAgent className='!p-0 !m-0' />

          {showUserProfile && (
            <Row as={Link} href={`/profile`} className='gap-md justify-between'>
              <Row className='w-fit gap-md'>
                <Avatar className='h-10 w-10'>
                  <AvatarImage
                    src={
                      authDetails?.details?.photo?.largeURL
                        ? `${globalConfig.baseImageUrl}${authDetails?.details?.photo?.largeURL}`
                        : '/images/placeholder.webp'
                    }
                    alt='User'
                  />
                  <AvatarFallback className='text-neutral-surface-100'>
                    {authDetails?.details?.firstName}
                  </AvatarFallback>
                </Avatar>

                <Col className='gap-xs'>
                  <Typography
                    size='sm'
                    weight='bold'
                    color='text-neutral-surface-100'
                  >
                    {authDetails?.details?.firstName}{' '}
                    {authDetails?.details?.lastName ||
                      t(`profileLayout_my_account`)}
                  </Typography>
                  <Typography size='xs' color='text-neutral-surface-80'>
                    {t('dashboardAgent_welcome_back')}
                  </Typography>
                </Col>
              </Row>
              <Row className='gap-xs w-fit'>
                <ButtonLink
                  variant='transparent'
                  color='base'
                  size='xs'
                  href='/messages'
                  startIcon={<Icon name='EnvelopeClose' size='md' />}
                />
                <ButtonLink
                  variant='transparent'
                  color='base'
                  size='xs'
                  href='/profile'
                  startIcon={<Icon name='Gear' size='md' />}
                />
              </Row>
            </Row>
          )}
        </Col>
      )}
    </Card>
  )
}
